import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApp } from "@/context/AppContext";
import { LANGS } from "@/lib/i18n";

export function LangSwitch({ compact = false }) {
  const { lang, setLang } = useApp();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid="language-switcher-select" className={`h-10 rounded-full bg-white text-foreground gap-1.5 font-bold ${compact ? "w-auto px-3" : "w-full h-12"}`}>
        <Globe className="w-4 h-4 shrink-0" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LANGS.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`} className="text-base py-3">
            {compact ? l.short : l.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
